import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cuándo recibo el ebook?',
  a: 'Recibirás acceso inmediato luego de realizar la compra. Podrás verlo y descargarlo al instante.'
}, {
  q: '¿Cómo accedo al contenido?',
  a: 'Una vez que compres, recibirás un link por email para acceder al ebook desde cualquier dispositivo.'
}, {
  q: '¿Necesito experiencia previa en nutrición canina?',
  a: 'No. Este ebook está pensado especialmente para principiantes, con explicaciones simples y paso a paso.'
}, {
  q: '¿Qué pasa si no me gusta o no es lo que esperaba?',
  a: 'Tenés una garantía de 7 días. Si sentís que no es para vos, podés solicitar la devolución.'
}, {
  q: '¿Puedo usarlo desde el celular?',
  a: 'Sí, podés verlo perfectamente desde el celular, tablet o computadora.'
}, {
  q: '¿El ebook incluye ejemplos prácticos?',
  a: 'Sí, incluye ejemplos reales, recetas y un plan semanal para que puedas aplicarlo fácilmente.'
}, {
  q: '¿Es seguro alimentar a mi perro con comida natural?',
  a: 'Sí, siempre que esté bien balanceada. En este ebook aprenderás exactamente cómo hacerlo sin errores.'
}, {
  q: '¿Cuánto tiempo lleva preparar la comida natural?',
  a: 'Con una buena organización, podés preparar la comida de toda la semana en poco tiempo y evitar cocinar todos los días.'
}, {
  q: '¿Voy a saber exactamente qué cantidades darle a mi perro?',
  a: 'Sí, el ebook incluye guías claras para calcular porciones según el peso de tu perro.'
}, {
  q: '¿Este ebook sirve para cualquier tipo de perro?',
  a: 'Sí, está diseñado para adaptarse a distintos tamaños y necesidades, con recomendaciones generales seguras.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 px-4 bg-lightgreen" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4 font-serif" data-id="element-57">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto rounded-full" data-id="element-58"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-59">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className={`bg-white rounded-xl border ${isOpen ? 'border-primary shadow-md' : 'border-sage shadow-sm'} overflow-hidden transition-all duration-300`} data-id="element-60">
                <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-61">
                  <span className={`font-semibold text-lg pr-4 ${isOpen ? 'text-primary' : 'text-charcoal'}`} data-id="element-62">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-primary' : 'text-gray-400'}`} data-id="element-63" />
                </button>

                <AnimatePresence data-id="element-64">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-65">
                      <div className="px-6 pb-5 text-gray-600 border-t border-gray-50 pt-3" data-id="element-66">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}